<template>
  <div>
    <PlantillaContenido>
      <div slot="titulo"> 
      <i class="fas fa-users-cog icon"></i>
        Tipo de Preguntas
      </div>
      
      <div slot="breadCrumb">
        <nav class="breadcrumb" aria-label="breadcrumbs">
          <ul> 
            <li>
              <router-link :to="{name:'administrativeHome'}" >
                <span >
                  <i class="fas fa-home icon"></i>                  
                   inicio
                </span>
              </router-link>
            </li>
            <li class="is-active">
              <router-link :to="{name: 'stablishment'}">
                <span>
                 <i class="fas fa-user-cog icon"></i>
                  Tipo de Preguntas
                </span>
              </router-link>
            </li>
          </ul>
        </nav>
      </div>

      <div slot="contenido">
        <div class="box">

          <createTypeSelection 
          v-if="isComponentModalActive"
          :isComponentModalActive="isComponentModalActive"
          :closeBasic="closeBasic"
          :chargeTypeSelectionList="chargeTypeSelectionList"
          :typeSelection_id="typeSelection_id">
          </createTypeSelection>
          <b-button type="is-primary is-small" @click="openBasic()">Crear Tipo de Pregunta</b-button>

          <b-table type="is-primary"
            :data.sync="listTypeSelection"
            :loading="loading"
            :paginated="isPaginated"
            :per-page="perPage"
            :current-page.sync="currentPage"
            :pagination-simple="isPaginationSimple"
            :default-sort-direction="defaultSortDirection"
            :sort-icon="sortIcon"
            :sort-icon-size="sortIconSize"
            :is-fullwidth="true"
            default-sort="type_selection.name"
            aria-next-label="Next page"            
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column field="name" label="Nombre">{{ props.row.name }}</b-table-column>

              <b-table-column label="Action">
                        <b-button type="is-primary is-small" @click="editBasic(props.row.id)">Editar</b-button>

              </b-table-column>
            </template>
          </b-table>
          
        </div>
      </div>
    </PlantillaContenido>
  </div>
</template>
<script>
import PlantillaContenido from '../../../../template/PlantillaContenido'
import createTypeSelection from '../../../../components/administrative/manteiners/type_selection/create';

export default {
  components: {
    PlantillaContenido,
    createTypeSelection
  },
  data() {
    return {
      typeSelection_id: null,
      listTypeSelection: [],
      isFullPage: true,
      isComponentModalActive: false,
      isPaginated: true,
      loading: false,
      isPaginationSimple: false,
      paginationPosition: "bottom",
      defaultSortDirection: "asc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      currentPage: 1,
      perPage: 5
    };
  },
  mounted: function() {
    this.chargeTypeSelectionList();
  },
  methods: {
    openBasic() {
      this.isComponentModalActive = true;
    },
    closeBasic() {
      this.typeSelection_id = null;
      this.isComponentModalActive = false;
    },
    editBasic(id) {
      this.typeSelection_id = id;
      this.isComponentModalActive = true;
    },
    chargeTypeSelectionList() {
      this.loading = true;
      this.listTypeSelection = [];
      this.$http.get(`api/${localStorage.getItem('perfil')}/type_selection`).then(
        response => {
          this.listTypeSelection = response.body.data;
          this.loading = false;
        },
        response => {
          console.log("error: ", response);
        }
      );
    }
  },
  
};
</script>

